<template>
    <transition name='fade-in'>
        <div class='scroll-to-top-button'
            aria-label='Scroll back to the top'
            @click='scrollBackToTop'
            v-show='show'>
            <div class='arrow'>
                <img class='rotate90' src="/images/arrow_large_white.svg">
            </div>
            <div class='total'>
                <small>{{total}}</small>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {

        props: ['total'],
        data: function () {
            return {
                show: false,
            }
        },
        created: function () {
            $(document).on('scroll', this.checkScrollPosition)
        },
        destroyed: function () {
            $(document).off('scroll', this.checkScrollPosition)
        },
        methods: {
            scrollBackToTop: function () {
                $(document).scrollTop(0)
            },
            checkScrollPosition: function () {
                if ($(document).scrollTop() > 700) {
                    this.show = true
                } else {
                    this.show = false
                }
            }
        }
    }
</script>

<style lang='scss' scoped>
    @import '../../sass/variables.scss';

    .scroll-to-top-button {
        background-color: $blue;

        position: fixed;
        bottom: 32px;
        right: 32px;
        color: white;

        height: 75px;
        width: 75px;

        border: none;
        border-radius: 50%;
        -webkit-border-radius: 50%;

        box-shadow: 0 6px 10px 0 rgba(0,0,0,0.3);
        cursor: pointer;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            right: 30px;
        }

        .total {
            text-align: center;
        }

        .arrow {
            margin-left: 30px;
            margin-top: 9px;
        }
    }
</style>
